import { BIM360Hub } from './BIM360Hub';

export abstract class ForgeUser
{
    public forgeID: string = '';
    public email: string = '';
    public name: string = '';
    public roleIds: any[] = [];
    public id: string = '';

    public abstract getAccessibleHubs(): Promise<BIM360Hub[]>;
}
